export class ReminderSettingEntity {
  disabled?: boolean
  firstDelay?: number
  attemptDelay?: number
  numberOfAttempts?: number
}
